"use strict";

import i18n from "../i18n";
import { responseCodes } from "../_redux/_constants";

const customErrorMessages = (errorResponse) => {
  if (
    errorResponse.statusCode === responseCodes?.CHECK_PASSWORD_CONTAIN_USERNAME
  ) {
    errorResponse.message = "Password should not consist part of the username.";
  }

  if (
    errorResponse.statusCode ===
    responseCodes.FUND_TRANSFER_OWN_ACCOUNT_ERROR_CODE
  ) {
    errorResponse.message = i18n.t(
      "You cannot transfer to your own LOLC account using this option. Please use the 'Own Account' transfer option instead.",
    );
  }

  if (errorResponse.statusCode === responseCodes?.CBD_DOWN_ERROR_CODE) {
    errorResponse.message = i18n.t(
      "We encountered an issue on our end. Please try again later.",
    );
  }

  if (
    errorResponse.statusCode ===
      responseCodes.AUTH_ERROR_IB_ACCOUNT_BLOCK_ADMIN ||
    errorResponse.statusCode ===
      responseCodes?.AUTH_ERROR_CUSTOMER_ONBOARD_FEBA_TO_WEB_ACCOUNT_BLOCK
  ) {
    errorResponse.message =
      "Your online banking account has been blocked by the admin. Please call the below number for assistance.";
  }

  if (
    errorResponse.statusCode ===
    responseCodes?.AUTH_ERROR_CUSTOMER_ONBOARD_WITH_PASSWORD_INVALID_PASSWORD_FORMAT
  ) {
    errorResponse.message = "Password should not consist part of the username.";
  }

  if (
    errorResponse.statusCode ===
    responseCodes?.CHANGE_PASSWORD_CURRENT_PASSWORD_INCORRECT
  ) {
    let attempt = "attempts";

    if (errorResponse?.errorDetails?.remainingAttempts == "1") {
      attempt = "attempt";
    }

    errorResponse.message =
      "The existing passcode that you have entered is incorrect. Please try again!";
    errorResponse.message2 =
      "You have " +
      errorResponse?.errorDetails?.remainingAttempts +
      " " +
      attempt +
      " to try again";
  }

  if (
    // errorResponse.statusCode ===
    //     responseCodes.AUTH_ERROR_ACCOUNT_BLOCK_OTP ||
    errorResponse.statusCode === responseCodes.AUTH_ERROR_ACCOUNT_BLOCK ||
    errorResponse.statusCode ===
      responseCodes.AUTH_ERROR_FORGOT_PASSWORD_OTP_CONFIRM_ADMIN_BLOCK
  ) {
    errorResponse.message =
      "Your account has been blocked by the admin. Please call the below number for assistance.";
  }

  if (
    errorResponse.statusCode === responseCodes.AUTH_ERROR_PASSWORD_INCORRECT ||
    errorResponse.statusCode === responseCodes.AUTH_ERROR_PASSCODE_INCORRECT
  ) {
    let attempt = "attempts";

    if (errorResponse?.errorDetails?.remainingAttempts == "1") {
      attempt = "attempt";
    }

    errorResponse.message =
      "You have " +
      errorResponse?.errorDetails?.remainingAttempts +
      " " +
      attempt +
      " to try again";
  }

  if (
    errorResponse.statusCode ===
      responseCodes.SETTING_AUTH_ERROR_PASSWORD_INCORRECT ||
    errorResponse.statusCode ===
      responseCodes.APPLICATION_SETTING_PW_CHANGE_INCORRECT_PW_ATTEMPT
  ) {
    const count = errorResponse?.errorDetails?.remainingAttempts;
    const key = count === 1 ? "attemptMessage" : "attemptMessage_plural";

    errorResponse.message = i18n.t(key, { count });
  }

  if (errorResponse.statusCode === responseCodes.OTP_FAILED) {
    const count = errorResponse?.errorDetails?.remainingAttempts;
    const key = count === 1 ? "attemptMessage" : "attemptMessage_plural";

    errorResponse.message =
      i18n.t("Invalid OTP") + ". " + i18n.t(key, { count });
  }

  if (errorResponse.statusCode === responseCodes.ONBOARDING_OTP_FAILED) {
    const count = errorResponse?.errorDetails?.remainingAttempts;
    const key = count === 1 ? "attemptMessage" : "attemptMessage_plural";

    errorResponse.message =
      i18n.t("Invalid OTP") + ". " + i18n.t(key, { count });
  }

  if (
    errorResponse.statusCode === responseCodes.OB_ACCOUNT_LOCKED ||
    errorResponse.statusCode === responseCodes.OTP_BLOCKED ||
    errorResponse.statusCode ===
      responseCodes.APPLICATION_SETTING_PW_CHANGE_TEMP_ACC_LOCKED ||
    errorResponse.statusCode === responseCodes.ONBOARDING_ACCOUNT_BLOCKED
  ) {
    errorResponse.message = errorResponse?.errorDetails?.remainingTime;
  }

  if (errorResponse.statusCode === responseCodes.OTP_EXPIRED) {
    errorResponse.message = i18n.t(
      "OTP expired. Request a new one to try again.",
    );
  }

  if (
    errorResponse.statusCode === responseCodes.AUTH_ERROR_ADMIN_ACCOUNT_BLOCK
  ) {
    errorResponse.message =
      "Your account has been blocked by the admin. Please call the below number for assistance.";
  }

  if (errorResponse.statusCode === responseCodes.TRANFER_RULE_VIOLATION) {
    errorResponse.message =
      "We are unable process your fund transfer due to transfer restrictions.";
  }

  if (
    errorResponse.statusCode === responseCodes.TRANSFER_MAXIMUM_LIMIT_VIOLATION
  ) {
    errorResponse.message =
      "The entered amount does not meet the maximum transfer limit in your account.";
  }

  if (
    errorResponse.statusCode === responseCodes.TRANSFER_MINIMUM_LIMIT_VIOLATION
  ) {
    errorResponse.message =
      "The entered amount does not meet the minimum transfer limit in your account.";
  }

  if (errorResponse.statusCode === responseCodes.BILL_PAYMENT_MAX_AMNT_ERROR) {
    errorResponse.message =
      "The entered amount exceeds the maximum transaction limit of the merchant.";
  }

  if (
    errorResponse.statusCode === responseCodes.AUTH_ERROR_DIFFERENT_DEVICE_LOGIN
  ) {
    errorResponse.message =
      "We have detected another new login to your account, so you've been automatically logged out. If you didn't do this, please log in again or contact our Customer Support.";
  }

  if (
    errorResponse.statusCode ===
    responseCodes.AUTH_ERROR_SERVICE_SESSION_INVALID
  ) {
    errorResponse.message =
      "Your session has expired. To get back in, please login again.";
  }

  if (
    errorResponse.statusCode ===
    responseCodes.AUTH_ERROR_SERVICE_SESSION_TIME_OUT
  ) {
    errorResponse.message =
      "Your session has expired. To get back in, please login again.";
  }

  if (errorResponse.statusCode === responseCodes.IDLE_TIMEOUT_LOGOUT_CODE) {
    errorResponse.message =
      "Your session has expired. To get back in, please login again.";
  }

  if (
    errorResponse.statusCode ===
    responseCodes.AUTH_ERROR_FORGOT_PASSWORD_DEBIT_CARD_PIN_INCORRECT
  ) {
    let attempt = "attempts";

    if (errorResponse?.errorDetails?.remainingAttempts == "1") {
      attempt = "attempt";
    }

    errorResponse.message =
      "Invalid PIN. Please check and re-enter. You have " +
      errorResponse?.errorDetails?.remainingAttempts +
      " " +
      attempt +
      " to try again";
  }

  if (
    errorResponse.statusCode ===
    responseCodes.AUTH_ERROR_FORGOT_PASSWORD_ADMIN_TEMP_BLOCK
  ) {
    errorResponse.message =
      "This option has been blocked by the admin. Please call the below number for assistance. This option will get automatically unblocked in " +
      errorResponse.errorDetails.remainingTime;
  }

  if (
    errorResponse.statusCode ===
    responseCodes.AUTH_ERROR_FORGOT_PASSWORD_ADMIN_BLOCK
  ) {
    errorResponse.message =
      "This option has been blocked by the admin. Please call the below number for assistance.";
  }

  if (
    errorResponse.statusCode === responseCodes.AUTH_ERROR_FORGOT_PASSWORD_BLOCK
  ) {
    errorResponse.message =
      "This option has been blocked. Please call the below number for assistance.";
  }

  if (errorResponse.statusCode === responseCodes.PAYMENT_NOT_ACCEPT) {
    errorResponse.message = "Merchant accept payments only from bank accounts.";
  }

  if (
    errorResponse.statusCode === responseCodes.AUTH_ERROR_ACCOUNT_NOT_ACTIVE
  ) {
    errorResponse.message =
      "Sorry! Your account is inactive. Please call the below number for assistance.";
  }

  if (
    errorResponse.statusCode ===
    responseCodes.AUTH_ERROR_FORGOT_PASSWORD_DO_NOT_HAVE_CARD
  ) {
    errorResponse.message =
      "Your registered account does not have a linked debit card. Please call the below number for assistance";
  }

  if (errorResponse.statusCode === responseCodes.MOBILE_NO_VALIDATION_FAILED) {
    errorResponse.message = "Please enter a valid mobile number";
  }

  if (errorResponse.statusCode === responseCodes.PAYONID_LIMIT_VIOLATION) {
    errorResponse.message =
      "Cash to mobile cannot be proceeded due to limit \n violation.";
  }

  if (
    errorResponse.statusCode ===
    responseCodes.PAYONID_ACCOUNT_BALANCE_INSUFFICIENT
  ) {
    errorResponse.message =
      "Insufficient balance! Please select another account.";
  }

  return errorResponse;
};

export { customErrorMessages };
